import { useExploraState } from 'app/store/explora-context';
import useWindowSize from 'hooks/useWindowSize';
import React from 'react';
import DynamicImage from 'shared/components/DynamicImage/DynamicImage';
import TextBody from 'shared/components/TextBody/TextBody';
import TextHeadline from 'shared/components/TextHeadline/TextHeadline';
import WithBackground from 'shared/hoc/WithBackground';
import { FontColor, FontSize } from 'shared/styles/typography';
import './WhatWeDo.scss';
import PrimaryButton from "../../../../shared/components/PrimaryButton/PrimaryButton";
import {EXPLORA_ROUTES} from "../../../explora-routes";
import {useHistory} from "react-router-dom";
import DynamicImageIcon from 'shared/components/DynamicImageIcon/DynamicImage';

const Us = () => {
  const { isLTDesktop } = useWindowSize();
  const { homeContent } = useExploraState();
  const { whatWeDo } = homeContent;
  const history = useHistory();

  const whatWeDoImages = ['microphone-podcast', 'video-podcast', 'transcript-podcast'];

  return (
    <WithBackground imageName="what-we-do">
      <TextHeadline component="h1" color={FontColor.SecondaryMain} size={FontSize.ExtraLarge} style={{ textAlign: 'center' }} bold>
        {whatWeDo.title}
      </TextHeadline>
      <div className="home-what-we-do__container">
        {whatWeDo.body.map(({ title, body }, index) => (
          <section className="home-what-we-do__description" key={title}>
            {!isLTDesktop && (
              <DynamicImageIcon className="home-what-we-do__microphone-icon" imageName={whatWeDoImages[index]} alt="podcast logo" />
            )}
            <div className="home-what-we-do__header-container">
              {isLTDesktop && (
                <DynamicImageIcon className="home-what-we-do__microphone-icon" imageName={whatWeDoImages[index]} alt="podcast logo" />
              )}
              <TextBody bold component="h1" color={FontColor.SecondaryMain} size={FontSize.Large} style={{ marginBottom: '1rem' }}>
                {title}
              </TextBody>
            </div>
            <TextBody component="p" color={FontColor.SecondaryMain} size={FontSize.Medium} style={{ textAlign: 'center' }}>
              {body}
            </TextBody>
          </section>
        ))}
      </div>
        <div style={{ display: 'flex', marginTop:'4rem',justifyContent:'center'}}>
            <PrimaryButton
                backgroundColor={FontColor.PrimaryLight}
                onClick={() => history.push(EXPLORA_ROUTES.Contact)}
                style={{ marginTop: '1rem' }}
            >
                <TextBody component="span" size={FontSize.Medium}>
                    Contactanos
                </TextBody>
            </PrimaryButton>
        </div>
    </WithBackground>
  );
};

export default Us;
